import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 30 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsx("mask", {
        id: "58vjgdrh1__mask0_9235_42331",
        style: {
          maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "30",
        height: "30",
        children: _jsx("path", {
          d: "M1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15Z",
          fill: "#C4C4C4",
          stroke: "#152361",
          strokeWidth: "2"
        })
      }), _jsxs("g", {
        mask: "url(#58vjgdrh1__mask0_9235_42331)",
        children: [_jsx("rect", {
          x: "-4.75",
          y: "1.25",
          width: "38.9074",
          height: "27.5",
          rx: "1.75",
          fill: "white",
          stroke: "#F5F5F5",
          strokeWidth: "0.5"
        }), _jsx("mask", {
          id: "ediu7xf4x__mask1_9235_42331",
          style: {
            maskType: "alpha"
          },
          maskUnits: "userSpaceOnUse",
          x: "-5",
          y: "1",
          width: "40",
          height: "28",
          children: _jsx("rect", {
            x: "-4.75",
            y: "1.25",
            width: "38.9074",
            height: "27.5",
            rx: "1.75",
            fill: "white",
            stroke: "white",
            strokeWidth: "0.5"
          })
        }), _jsxs("g", {
          mask: "url(#ediu7xf4x__mask1_9235_42331)",
          children: [_jsx("rect", {
            x: "21.2734",
            y: "1",
            width: "13.1358",
            height: "28",
            fill: "#F44653"
          }), _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M-5 29H8.1358V1H-5V29Z",
            fill: "#1035BB"
          })]
        }), _jsx("path", {
          d: "M1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15Z",
          stroke: "#152361",
          strokeWidth: "2"
        })]
      })]
    }))
  });
};
export default Component;
